export const fmt = (n: number) => n.toLocaleString('en-US')

export type SortDir = 'asc' | 'desc'

export const INSIGHTS_CACHE_TTL_SECONDS = 180
